<template>
    <div class="home-page">
        <div class="bannerVideo-wrap">
            <video class="absolute" playsinline id="homeVideo" :class="{blurClass:isBlur}" :src="bannerVideo" autoplay loop muted poster="https://resource.tanwuapp.com/FngsrQe5ZIwn-CGJuWSFa2il0Hi7" @canplay="bannerVideoPlay" :style="fixStyle"></video>
        </div>
        <div class="banner-content">
            <div class="absolute center font-20">
                <swiper class = "swiper" :options="swiperOptionPartner">
                    <swiper-slide v-for="(item,index) in bannerSwiperData" :key="index">
                        <p class="title">{{item.title}}</p>
                        <p class="desc" v-for="(item2,index2) in item.content" :key="index2">{{item2}}</p>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
                <router-link to="/aboutUs" class="btn-more select-point"  data-text = "了解更多探物"></router-link>
            </div>
            <p class="videoBar">
                <span :style="{'width':videoBarWidth + '%'}"></span>
            </p>
            <!-- <span class="voice-btn">click</span> -->
        </div>
        <publicHeader class="home-header" :isHome = 'bannerFlag' :class="{active:!bannerFlag}"></publicHeader>
        <div class="bg-white part">
            <div class="container">
                <div class="part-title display-flex-between flex-align-center">
                    <span>探物资讯</span>
                    <!-- <router-link to="/news" class="btn select-point">了解更多</router-link> -->
                </div>
                <div>
                    <!-- <newsItem v-for="(item,index) in newsList" :key="index" :item = "item" @click.native="goDetail(item)"></newsItem> -->
                    <newsItemHome v-for="(item,index) in newsList" :key="index" :item = "item" @click.native="goDetail(item)"></newsItemHome>
                </div>
            </div>
        </div>
        <div class="rent-part part">
            <div class="container">
                <div class="part-title display-flex-between flex-align-center">
                    <span>租赁中心</span>
                    <router-link to="/rent" class="btn select-point">了解更多</router-link>
                </div>
                <rentBox></rentBox>
            </div>
        </div>
        <div class="assess-part part" id="assess">
            <div class="container relative">
                <div class="part-title display-flex-between flex-align-center color-white">
                    <span>产品评测</span>
                    <router-link to="/assess" class="btn select-point">了解更多</router-link>
                </div>
                <!-- <div class="assess-list" id="assess-list">
                    <assessItem v-for="(item,index) in videoList" :key="index" :item = "item" class="item" :class="{active:index == assessIndex || index == assessIndex + 1}"></assessItem>
                </div> -->
                <!-- <span class="action btn-left" v-show="assessIndex" @click="scrollAssess('left')"></span>
                <span class="action btn-right" v-show="assessIndex < videoList.length - 2" @click="scrollAssess('right')"></span> -->
                <swiper :options="swiperOptionVideo" class="video-swiper">
                    <swiper-slide v-for="(item,index) in videoList" :key="index">
                        <assessItem :item = "item" class="item" :class="{active:index == assessIndex || index == assessIndex + 1}"></assessItem>
                    </swiper-slide>
                </swiper>
                <span class="action btn-left my-swiper-prev" slot="button-prev"></span>
                <span class="action btn-right my-swiper-next" slot="button-next"></span>
            </div>
        </div>
        <div class="partner-part part">
            <div class="container">
                <div class="part-title display-flex-between flex-align-center">
                    <span>合作伙伴</span>
                </div>
                <partnerBox></partnerBox>
            </div>
        </div>
        <scrollTop></scrollTop>
        <publicFooter></publicFooter>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    import publicHeader from '@components/header';
    import publicFooter from '@components/footer';
    import scrollTop from '@components/scrollTop';
    import newsItem from '@components/newsItem';
    import newsItemHome from '@components/newsItemHome';
    import assessItem from '@components/assessItem';
    import rentBox from '@components/rentBox';
    import partnerBox from '@components/partnerBox';
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
		data() {
			return {
                // bannerVideo:'https://resource.tanwuapp.com/admin/video/1573442240007',
                bannerVideo:'https://resource.tanwuapp.com/admin/video/1575023049308',
                bannerFlag:true,
                fixStyle:'',
                isBlur:false,
                newsList:[

                    {
                        id:5,
                        image:'https://prod-static.tanwuapp.com/official-website/20250930-100409.jpg',
                        title:'探物与支付宝联袂呈现“租着玩”快闪店登陆长沙，万物可租引领旅行新风向',
                        time:'2025.05.08',
                        link:'https://prod-static.tanwuapp.com/official-website/shangshaEvent.html'
                    },
                    {
                        id:4,
                        image:'https://resource.tanwuapp.com/tanworthPc2.0/lQLPJxZjLzdYy-rM9s0BfrBIk8DAbydSOQKjkfHHgPgA_382_246.png',
                        title:'探物联手芝麻推出1分钱露营体验活动，快速抢占露营市场先机',
                        time:'2022.06.06',
                        link:'https://mp.weixin.qq.com/s/uqY1gDKxkIDbrblIhgfscA'
                    },
                    {
                        id:1,
                        image:'https://resource.tanwuapp.com/FkgGTShNPh5nrpXAnWdLY0sVw4zO',
                        title:'探物荣登「胡润百富 2019 中国最具投资价值新星企业」榜！',
                        time:'2019.06.29',
                        link:'https://mp.weixin.qq.com/s/qKudHIpBFFslKTFlzGbg7A'
                    },
                    {
                        id:2,
                        image:'https://resource.tanwuapp.com/FpYDm0e1k6BhicDHs5YJuD-jIgux',
                        title:'36氪首发 | 定位新奇科技数码租赁平台，「探物」获蚂蚁金服数千万元天使轮融资',
                        time:'2018.04.13',
                        link:'https://mp.weixin.qq.com/s/CAM2p6DpVcDpibWpg3Uqtw'
                    },
                    // {
                    //     id:3,
                    //     image:'https://resource.tanwuapp.com/FvpZ4OMGvVZhW2LrXo3uBLIDt6_Z',
                    //     title:'仅有21人的公司，凭什么被十几家风投疯抢？',
                    //     time:'2018.02.01',
                    //     link:'https://mp.weixin.qq.com/s/UjLdeQPJJaB2AlHox3JY4w'
                    // }
                ],
                videoList:[],
                assessIndex:0,
                swiperOptionPartner:{
                    loop: true,
                    autoplay:true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    disableOnInteraction: false
                },
                bannerSwiperData:[
                    {
                        title:'以租代买 租享更尽兴',
                        content:['探物与众多一线品牌合作，为消费者提供最新、最丰富的数码产品','为消费者带来更具品质的租赁服务']
                    },
                    {
                        title:'数码租赁 消费新体验',
                        content:['以租代买，解决数码产品强需求却低频使用的痛点','拒绝闲置浪费，开启全新的消费体验']
                    },
                    {
                        title:'年轻人的数码库',
                        content:['探物团队深入市场力求帮用户甄选好玩、有趣的新奇数码','目前已累计数千款SKU，随用随租更轻松']
                    }
                ],
                videoBarWidth:0,
                swiperOptionVideo:{
                    // loop:true,
                    slidesPerView: 2,
                    spaceBetween: 20,
                    // centeredSlides: true
                    navigation: {
                        nextEl: '.my-swiper-next',
                        prevEl: '.my-swiper-prev'
                    }
                },

			}
        },
        components: {
            swiper,
            swiperSlide,
            publicHeader,
            publicFooter,
            scrollTop,
            newsItem,
            newsItemHome,
            assessItem,
            rentBox,
            partnerBox
		},
        created(){
            // network(CONFIG.homes).then(res => {
            //     let themes = res.details.themes.slice(0,3);
            //     let newsList = [];
            //     themes.map(item => {
            //         newsList.push({
            //             id:item.themeId,
            //             image:item.themeBigImage,
            //             title:item.themeTitle,
            //             time:this.initTime(item.themeCreateDatetime)
            //         })
            //     });
            //     this.newsList = newsList;
            // })
            network(CONFIG.videosByType,{
                pageNumber:1,
                pageSize:8,
                videoTypeId:0,
                orderBy:1
            }).then(res => {
                let list = [];
                res.data.map(item => {
                    list.push({
                        id:item.videoId,
                        image:item.background,
                        title:item.title,
                        time:this.formatTime(item.datetime)
                    })
                });
                this.videoList = list;
            });
        },
        mounted: function() {
            window.onresize = () => {
                const windowWidth =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                const windowAspectRatio = windowHeight / windowWidth
                let videoWidth
                let videoHeight
                if (windowAspectRatio < 0.5625) {
                    videoWidth = windowWidth
                    videoHeight = videoWidth * 0.5625
                    this.fixStyle = {
                        height: windowWidth * 0.5625 + 'px',
                        width: windowWidth + 'px',
                        'margin-bottom': (windowHeight - videoHeight) / 2 + 'px',
                        'margin-left': 'initial'
                    }
                } else {
                    videoHeight = windowHeight
                    videoWidth = videoHeight / 0.5625
                    this.fixStyle = {
                        height: windowHeight + 'px',
                        width: windowHeight / 0.5625 + 'px',
                        'margin-left': (windowWidth - videoWidth) / 2 + 'px',
                        'margin-bottom': 'initial'
                    }
                }
            }
            window.onresize();
            const $assess = document.getElementById('assess');
            if($assess){
                window.addEventListener('scroll',e => {
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                    this.isBlur = scrollTop + windowHeight > $assess.offsetTop;
                    this.bannerFlag = scrollTop <= windowHeight/2;
                },true)
            }
            this.initVideoBar();
        },
        methods:{
            initVideoBar(){
                const $homeVideo = document.getElementById('homeVideo');
                if($homeVideo){
                    $homeVideo.addEventListener('timeupdate',()=> {
                        this.videoBarWidth = $homeVideo.currentTime / $homeVideo.duration * 100;
                    })
				}
            },
            bannerVideoPlay(){
                //开始播放的时候
            },
            scrollAssess(type){
                let assessIndex = this.assessIndex;
                const $assessList = document.getElementById('assess-list');
                this.assessIndex = type == 'right' ? assessIndex + 1 : assessIndex - 1;
                $assessList.style.transform = "translateX(" + -610 * this.assessIndex + "px)";
            },
            goDetail(item){
                window.open(item.link)
                // this.$router.push("/newsDetail?id="+item.id)
            },
            initTime(value){
                let time = value.split(' ')[0].replace(/-/g,'.');
                return time
            },
            toggleVoice(){
                
            }
        }
    }
</script>

<style lang="scss">
    @import '~@assets/css/style';
    .home-page{
        .public-header{
            // position: absolute;
            background: none;
            color: #ffffff;
            transition: background 0.3s,color 0.3s;
            border-color: rgba($color: #fff, $alpha: 0.2);
            &.active{
                background: #ffffff;
                color: #000000;
                border-color:rgba($color: #eee, $alpha: 0.5);
            }
        }
        .bannerVideo-wrap{
            position: fixed;
            width: 100%;
            left: 0;
            height: 100vh;
            overflow: hidden;
            z-index: -1;
            background: #000000;
            .blurClass{
                filter: blur(15px);
            }
        }
        .banner-content{
            position: relative;
            height: 100vh;
            color: #ffffff;
            .swiper{
                width: 800px;
                text-align: center;
                padding-bottom: 40px;
                .title{
                    font-weight: bold;
                    font-size: 54px;
                    line-height: 75px;
                    margin-bottom: 6px;
                }
                .desc{
                    font-size: 20px;
                    line-height: 34px;
                }
            }
            .swiper-pagination-bullet{
                border-color: #ffffff;
                &.swiper-pagination-bullet-active{
                    border-color: #3ED8C4;
                }
            }
            .btn-more{
                position: relative;
                font-size: 16px;
                display: block;
                margin: auto;
                margin-top: 30px;
                width: 160px;
                line-height: 48px;
                border: 1px solid #ffffff;
                border-radius: 25px;
                font-weight: bold;
                text-align: center;
                overflow: hidden;
                &::before{
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    top: 0;
                    width: 100%;
                    background: rgba($color: #ffffff, $alpha: 0.2);
                    transition: transform .4s ease-in-out;
                    transform: scaleX(0);
                    transform-origin: 100% 0;
                }
                &::after{
                    content: attr(data-text);
                    position: relative;
                }
                &:hover::before{
                    transform: scaleX(1);
                    transform-origin: 0 0;
                }
            }
            .videoBar{
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 3px;
                background: rgba($color: #ffffff, $alpha: 0.3);
                > span{
                    display: block;
                    height: 3px;
                    background: #3ED8C4;
                    transition: width 0.6s;
                }
            }
            .voice-btn{
                position: absolute;
                right: 20px;
                bottom: 20px;
                background: yellow;
                cursor: pointer;
                &.active{
                    background: red;
                }
            }
        }
        .part{
            padding: 70px 0;
            .part-title{
                font-size: 32px;
                margin-bottom: 30px;
                letter-spacing: 1px;
                .btn{
                    font-size: 16px;
                    background: url('~@assets/img/home-title-more.png') no-repeat right center;
                    background-size:16px 16px;
                    padding-right: 26px; 
                }
            }
        }
        .rent-part{
            background: #F5F6FA;
            overflow: hidden;
        }
        .assess-part{
            position: relative;
            overflow: hidden;
            &::before{
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: rgba($color: #000000, $alpha: 0.5);
            }
            .assess-list{
                white-space: nowrap;
                transition: transform 0.3s;
                .item{
                    opacity: 0.5;
                    transition: opacity 0.3s;
                    &.active{
                        opacity: 1;
                    }
                }
            }
            .video-swiper{
                overflow: visible!important;
                .swiper-slide{
                    opacity: 0.5;
                    transition: opacity 0.3s;
                }
                .swiper-slide-active,.swiper-slide-next{
                    opacity: 1;
                }
            }
            .action{
                position: absolute;
                top: 0;
                bottom: 0;
                width: 500px;
                cursor: pointer;
                z-index: 3;
                &.btn-left{
                    right: 100%;
                }
                &.btn-right{
                    left: 100%;
                }
            }
        }
        .partner-part{
            background: #ffffff url(~@assets/img/logo/logo-bg.jpg) repeat;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/pages/home.vue